import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { shortenAddress } from "@/helpers/address.helpers";
import { isValidEthAddress } from "@/helpers/Helpers";
import { useContractOverviewQuery } from "@/hooks/useAlchemyNftQueries";
interface UseCollectionContractDetailsArgs {
  readonly contract: string | null;
  readonly normalizedContract: string | null;
}
interface UseCollectionContractDetailsResult {
  readonly contractParam: string;
  readonly normalizedAddress: `0x${string}` | null;
  readonly contractDisplayName: string;
}
export function useCollectionContractDetails(t0) {
  const $ = _c(17);
  const {
    contract,
    normalizedContract
  } = t0;
  let t1;
  if ($[0] !== normalizedContract) {
    t1 = normalizedContract?.trim();
    $[0] = normalizedContract;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const normalized = t1;
  let t2;
  if ($[2] !== contract) {
    t2 = contract?.trim();
    $[2] = contract;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const raw = t2;
  const contractParam = normalized || raw || "";
  let t3;
  bb0: {
    if (!contractParam) {
      t3 = null;
      break bb0;
    }
    let t4;
    if ($[4] !== contractParam) {
      t4 = isValidEthAddress(contractParam) ? contractParam.toLowerCase() as `0x${string}` : null;
      $[4] = contractParam;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = t4;
  }
  const normalizedAddress = t3;
  const t4 = normalizedAddress ?? undefined;
  const t5 = Boolean(normalizedAddress);
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = {
      address: t4,
      enabled: t5
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const {
    data: contractOverview
  } = useContractOverviewQuery(t6);
  let t7;
  bb1: {
    if (contractOverview?.name) {
      t7 = contractOverview.name;
      break bb1;
    }
    let t8;
    if ($[9] !== contract) {
      t8 = contract?.trim();
      $[9] = contract;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    const trimmed = t8;
    if (normalizedAddress) {
      let t9;
      if ($[11] !== normalizedAddress) {
        t9 = shortenAddress(normalizedAddress);
        $[11] = normalizedAddress;
        $[12] = t9;
      } else {
        t9 = $[12];
      }
      t7 = t9;
      break bb1;
    }
    if (trimmed) {
      t7 = trimmed;
      break bb1;
    }
    t7 = "Selected collection";
  }
  const contractDisplayName = t7;
  let t8;
  if ($[13] !== contractDisplayName || $[14] !== contractParam || $[15] !== normalizedAddress) {
    t8 = {
      contractParam,
      normalizedAddress,
      contractDisplayName
    };
    $[13] = contractDisplayName;
    $[14] = contractParam;
    $[15] = normalizedAddress;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}